import React from 'react'
import { Section } from '../../ui'
import LogoPNG from '../../../assets/images/logo.png'

import './logoSection.scss'

const LogoSection = () => {

    return (
        <Section>
            <div className='logo_section'>
                <img className='logo_section-logo' src={LogoPNG} />
            </div>
        </Section>
    )
}

export default LogoSection